export default "__VITE_PUBLIC_ASSET__9912ffb3__"